<template>
  <div>
    <el-dialog ref='dialog' title="配置组合筛选" size="large">
      <div>
        <div style="width:35%;float:left;">
          <el-button type="primary" @click="addSelectMap()" size="small">添加筛选</el-button>
          <el-table
            :data="combinationData.select_map"
            border
            class="m-t-10"
            style="width: 100%">
            <el-table-column
              prop="date"
              label="名称">
              <template scope="scope">
                <el-input placeholder="填写名称" v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作">
              <template scope="scope">
                <el-button type="text" size="mini" @click="editCombination(scope.$index, scope.row)">编辑</el-button>
                <el-button type="text" size="mini" @click="copy(scope.$index, scope.row)">复制</el-button>
                <el-button type="text" size="mini" @click="deleteRow(scope.$index, combinationData.select_map)">移除</el-button>
                <el-button type="text" size="mini" v-if="scope.row.isCut" @click="cancelCut(scope.$index)">取消剪切</el-button>
                <el-button type="text" size="mini" v-else @click="cut(scope.$index, scope.row)">剪切</el-button>
                <el-button type="text" size="mini" @click="insert(scope.$index)">插入</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width:64%;float:right;" v-if="isEditComb"> 
          <condition
            :modelId="modelId"
            :config="editData"
            :inputList="inputList"
            :filterFieldIds="filterFieldIds"
            :userFields="userFields"
            :simpleField="simpleField"
          ></condition>
        </div>
      </div>
      <div class="footer fl" style="width:100%;">
        <el-button @click="closeDialog()" size="small">取消</el-button>
        <el-button type="primary" @click="submitData()" size="small">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
  .hr {
    clear:both;
    margin-bottom: 10px;
    margin-top:10px;
    height: 1px;
    background: #000000;
  }
  .el-dialog--small {
    width: 60%;
  }
  .el-table .tableColumnClass {
    height: 50px;
  }
  .footer {
    text-align: right;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
  }
  .selectMapName .el-form-item__content {
    float: left;
  }
  .content {
    max-height: 450px;
    overflow-y: auto;
  }
</style>
  
<script>
import http from '../../../assets/js/http'
import condition from '../../Common/business/conditionConfig/condition.vue'
export default {
  props: {
    tempCombinationData: {
      type: Object,
      default() {
        return {}
      }
    },
    dealId: {
      default() {
        return -1
      }
    },
    listModelId: {
    },
    filterFieldIds: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      combinationData: {},
      conditionLogicList: [ // 条件逻辑
        { 'name': 'AND' },
        { 'name': 'OR' }
      ],
      typeList: [ // 值类型
        { id: 10, name: '常量' },
        { id: 20, name: '日期时间变量' }
      ],
      logicList: [ // 逻辑列表
        { value: '=', title: '等于' },
        { value: '<', title: '小于' },
        { value: '<=', title: '小于等于' },
        { value: '>', title: '大于' },
        { value: '>=', title: '大于等于' },
        { value: '<>', title: '不等于' }
      ],
      rules: {
        name: [
          { required: true, message: '名称不能为空' , trigger: 'blur' }
        ]
      },
      editData: {},
      inputList: [],
      isEditComb: false,
      cutData: [],
      combModel: {
        fields: [{
          field_id: '',
          logic: 10,
          logic_name: '',
          type: 10,
          value: ''
        }],
        name: '',
        relation: ''
      },
      currentIndex: -1,
      userFields: []
    }
  },
  created() {
    this.getUserFields()
  },
  methods: {
    open() {
      this.combinationData = _.cloneDeep(this.tempCombinationData)
      this.$refs.dialog.open()
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    handleParams(arr) {
      setTimeout(() => {
        this.$emit('handleParams', arr)
      }, 0)
      this.closeDialog()
    },
    filterLogic() { // 过滤逻辑 将符号转化为文字
      let temp = this.combinationData.select_map
      if (temp && temp.length > 0) {
        _(temp).forEach((result) => {
          if (result.config && result.config.length > 0) {
            _(result.config).forEach((res) => {
              if (res.logic) {
                let temp = _.filter(this.logicList, { value: res.logic })
                if (temp.length > 0) {
                  res.logic = temp[0].title
                }
              }
            })
          }
        })
      }
    },
    // getSelectMapConfigModel() {
    //   let model = {
    //     field_id: null,
    //     logic: null,
    //     logic_map: null,
    //     type: null,
    //     value: null
    //   }
    //   return model
    // },
    // getSelectMaoModel() {
    //   let model = {
    //     config: [],
    //     name: null
    //   }
    //   model.config.push(this.getSelectMapConfigModel())
    //   return model
    // },
    moveSelectMap(index, index2) {
      let arr = this.combinationData.select_map
      arr[index] = arr.splice(index2 , 1 , arr[index])[0]
      this.combinationData.select_map = arr
    },
    moveUp(firstIndex) {
      this.moveSelectMap(firstIndex, firstIndex - 1)
    },
    moveDown(firstIndex) {
      this.moveSelectMap(firstIndex, firstIndex + 1)
    },
    addSelectMap() {
      let model = _.cloneDeep(this.combModel)
      this.combinationData.select_map.push(model)
    },
    // deleteSelectMap(firstIndex) {
    //   this.combinationData.select_map.splice(firstIndex, 1)
    // },
    // addSelectMapConfig(firstIndex) { // 添加一项
    //   let model = this.getSelectMapConfigModel()
    //   this.combinationData.select_map[firstIndex].config.push(model)
    // },
    deleteSelectMapConfig(firstIndex, SecondIndex) {
      this.combinationData.select_map[firstIndex].config.splice(SecondIndex, 1)
    },
    validateForm() {
      let validated = true
      if (this.$refs.form && this.$refs.form.length > 0) {
        _(this.$refs.form).forEach((curItem) => {
          curItem.validate((res) => {
            if (!res) {
              validated = false
            }
          })
        })
      }
      if (!validated) {
        _g.toastMsg(this, 'error', '名称不能为空')
      }
      return validated
    },
    submitData() {
      // 表单校验
      if (!this.validateForm()) {
        return
      }
      let arr = _.cloneDeep(this.combinationData.select_map)
      // 如果数据中存在选择时间常量，并且value不为空，则进行时间转换
      // if (arr && arr.length > 0) {
      //   _(arr).forEach((res) => {
      //     if (res.config && res.config.length > 0) {
      //       _(res.config).forEach((childRes) => {
      //         if (childRes.type === 20 && childRes.value) {
      //           childRes.value = _g.parseFormula(childRes.value)
      //         }
      //       })
      //     }
      //   })
      // }
      // 保存数据
      let postData = {
        filter: arr
      }
      this.apiPost(`cms/contents/${this.dealId}/buildFilter`, postData).then((res) => {
        if (res.code === 200) {
          this.tempCombinationData.select_map = this.combinationData.select_map
          _g.toastMsg(this, 'success', '保存成功')
          setTimeout(() => {
            this.$emit('handleParams')
          }, 200)
          this.closeDialog()
          return
        }
        _g.toastMsg(this, 'success', res.error ? res.error : '保存成功')
      })
    },
    editCombination(index, row) {
      this.editData = []
      this.isEditComb = true
      this.editData = this.combinationData.select_map[index]
    },
    cut(index, item) {
      let newTableObj = _.cloneDeep(item)
      newTableObj.cutIndex = index
      this.$set(item, 'isCut', true)
      this.cutData.push(newTableObj)
    },
    cancelCut(index) {
      this.combinationData.select_map[index].isCut = false
      _.remove(this.cutData, (res) => {
        return res.cutIndex == index
      })
    },
    insert(index) {
      if (_g.isRealEmpty(this.cutData)) {
        let newTableObj = _.cloneDeep(this.combModel)
        this.cutData = [newTableObj]
      } else {
        this.cutData.sort((a, b) => {
          return a.cutIndex > b.cutIndex
        })
      }
      let insertData = _.cloneDeep(this.cutData)
      _(insertData).forEach((res) => {
        delete res.cutIndex
      })
      this.combinationData.select_map.splice(index + 1, 0, ...insertData)
      _.remove(this.combinationData.select_map, (res) => {
        return res.isCut
      })
      this.currentIndex = _g.resetCurIndexByCut(this.cutData, this.currentIndex, index) // 重新获取当前选中项索引
      this.cutData = []
    },
    deleteRow(index, rows) {
      this.cancelCut(index)
      rows.splice(index, 1)
      if (this.currentIndex == index) {
        this.currentIndex = -1
      }
    },
    copy(index, rows) {
      let newObj = _.cloneDeep(rows)
      this.combinationData.select_map.splice(index, 0, newObj)
    },
    async getUserFields() {
      await this.apiGet('cms/deals/fields/1').then((res) => {
        if (res.code == 200) {
          this.userFields = res.data
        }
      })
    }
  },
  components: {
    condition
  },
  watch: {
    async 'listModelId'() {
      await this.apiGet(`cms/deals/fields/${this.listModelId}`).then((res) => {
        if (res.code == 200) {
          let arr = []
          _(res.data).forEach((res) => {
            if (res.field_id != 'id') {
              arr.push({
                default: {
                  name: res.field,
                  title: res.title,
                  field_id: res.field_id,
                  field_type: res.field_type
                }
              })
            }
          })
          this.$set(this, 'inputList', arr)
        }
      })
    }
  },
  mixins: [http]
}
</script>



// WEBPACK FOOTER //
// combinationDialog.vue?30a393c0